import moment from 'moment-timezone';

const dateFormat = (dateString) => {
  const formattedDate = moment(dateString).format('MM/DD/YYYY h:mm A');

  if (formattedDate === 'Invalid date') return '';
  
  return formattedDate;
};

export default dateFormat;